import { render, staticRenderFns } from "./assinatura.vue?vue&type=template&id=0c6112bb"
import script from "./assinatura.vue?vue&type=script&lang=ts"
export * from "./assinatura.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports